import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";
import { Calculator } from "lucide-react";
import ROICalculator from "./ROICalculator";
import DemoCTA from "./DemoCTA";
import { track } from "@/lib/track";
import { useSectionView } from "@/hooks/use-section-view";

const CTAMultiple = () => {
  const sectionRef = useSectionView<HTMLElement>("final_cta");
  const { t } = useTranslation();
  const [roiOpen, setRoiOpen] = useState(false);

  return (
    <section ref={sectionRef} className="py-20 lg:py-32 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center animate-fade-in">
          <div className="relative p-8 sm:p-12 lg:p-20 rounded-3xl bg-gradient-yellow overflow-hidden">
            <div className="absolute inset-0 bg-primary/5 backdrop-blur-sm" />

            <div className="relative z-10">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
                {t("ctaMultiple.title")}{" "}
                <span className="text-primary">{t("ctaMultiple.titleHighlight")}</span>
              </h2>
              <p className="text-lg text-muted-foreground mb-4 max-w-2xl mx-auto">
                {t("ctaMultiple.subtitle")}
              </p>
              <p className="text-base font-semibold mb-8">
                {t("ctaMultiple.price")}
              </p>

              <DemoCTA location="final_cta" />

              <Button variant="ghost" className="mt-4" onClick={() => { track("roi_open", { location: "final_cta" }); setRoiOpen(true); }}>
                <Calculator className="mr-2 h-4 w-4" />
                {t("ctaMultiple.calculateRoi")}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ROICalculator open={roiOpen} onOpenChange={setRoiOpen} />
    </section>
  );
};

export default CTAMultiple;
